import ztComponent from './ztButton.vue'
export default (Vue) => {
  Vue.component(ztComponent.name, ztComponent)
}
